<template>
  <FormSelect
    v-model="selection"
    size="sm"
    :options="options"
    name="date-range-picker"
    @change="onChange"
  />
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import FormSelect from '../components/form/FormSelect.vue';
import type { DateRange } from '../lib/services/TimeService';
import {
  DateSelection,
  getDateRangeOptions,
  getSinceBefore,
} from '../lib/services/TimeService';

const options = ref<{ text: string; value: DateSelection }[]>(
  getDateRangeOptions(),
);

const selection = ref<DateSelection>(DateSelection.All);

const emit = defineEmits<{
  (e: 'change', dateRange: DateRange): void;
}>();

const onChange = (e: DateSelection): DateRange => {
  const dateRange = getSinceBefore(e);
  emit('change', dateRange);
  return dateRange;
};

onMounted(() => {
  onChange(selection.value);
});
</script>
